import React from "react";
import {
  Skeleton,
  TableCell,
  TableCellProps,
  TableRow,
  TableRowProps,
} from "@mui/material";

export const getSkeletons = (cols = 10, rows = 10) => {
  return new Array(rows)
    .fill(null)
    .map((i) =>
      new Array(cols)
        .fill(null)
        .map(() => <Skeleton sx={{ width: "100%" }} key={"col-" + i} />)
    );
};
interface TableSkeletonsProps {
  cols?: number;
  rows?: number;
  checkable?: boolean;
  props?: {
    TableRowProps?: TableRowProps;
    TableCellProps?: TableCellProps;
  };
}

export const getTableSkeletons = ({
  cols = 10,
  rows = 10,
  checkable = false,
  props,
}: TableSkeletonsProps) => {
  const skeletons = getSkeletons(cols, rows);
  if (checkable) {
    return skeletons.map((row, i) => (
      <TableRow key={i} {...props?.TableRowProps}>
        <TableCell
          align={"center"}
          {...props?.TableCellProps}
          sx={{ p: 0, px: 8 }}
        >
          <Skeleton sx={{ width: 24 }} />
        </TableCell>
        {row.splice(1, row.length).map((el, index) => (
          <TableCell key={index}>
            <Skeleton sx={{ width: "100%" }} />
          </TableCell>
        ))}
      </TableRow>
    ));
  } else {
    return skeletons.map((row, i) => (
      <TableRow key={i} {...props?.TableRowProps}>
        {row.map((el, index) => (
          <TableCell {...props?.TableCellProps} key={index}>
            <Skeleton sx={{ width: "100%" }} />
          </TableCell>
        ))}
      </TableRow>
    ));
  }
};
